module.exports = __webpack_public_path__ + "img/linkedin.c24cde28.png";